import { render, staticRenderFns } from "./JSysenvTabBorder.vue?vue&type=template&id=19207514&"
import script from "./JSysenvTabBorder.vue?vue&type=script&lang=js&"
export * from "./JSysenvTabBorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
